(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tresse-product-page"] && !Shopify.designMode) return;
  try {
    
  function initTresseReviews(root) {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';
    const track = root.querySelector('.tresse__review-track');
    if (!track || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let paused = false;
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', () => window.setTimeout(resume, 3000), { passive: true });
    window.setInterval(() => {
      if (paused || !root.isConnected) return;
      const step = track.querySelector('blockquote')?.getBoundingClientRect().width || track.clientWidth * .9;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step + 14, behavior: 'smooth' });
    }, 4000);
  }
  function updateTresseDelivery(root) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const number = (type) => Number(parts.find((part) => part.type === type).value);
    const today = new Date(Date.UTC(number('year'), number('month') - 1, number('day')));
    const plusDays = (days) => new Date(today.getTime() + days * 86400000);
    const formatDate = (date) => {
      const day = date.getUTCDate();
      const suffix = day > 3 && day < 21 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
      const month = new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', month: 'short' }).format(date);
      return `${month} ${day}${suffix}`;
    };
    root.querySelector('[data-tresse-order-date]').textContent = formatDate(today);
    root.querySelector('[data-tresse-ship-date]').textContent = `${formatDate(plusDays(1))} – ${formatDate(plusDays(2))}`;
    root.querySelector('[data-tresse-arrival-date]').textContent = `${formatDate(plusDays(4))} – ${formatDate(plusDays(6))}`;
  }
  function updateAllTresseDeliveries(scope = document) {
    scope.querySelectorAll('[data-tresse-delivery]').forEach(updateTresseDelivery);
  }
  function initTresseSophiaPlayer(root) {
    if (root.dataset.playerReady === 'true') return;
    root.dataset.playerReady = 'true';
    const video = root.querySelector('video');
    const button = root.querySelector('.tresse__sophia-play');
    button.addEventListener('click', () => {
      video.play().catch(() => { button.hidden = false; });
    });
    video.addEventListener('play', () => { button.hidden = true; });
    video.addEventListener('pause', () => { button.hidden = false; });
    video.addEventListener('ended', () => { button.hidden = false; });
  }
  function initAllTresseSophiaPlayers(scope = document) {
    scope.querySelectorAll('[data-tresse-sophia-player]').forEach(initTresseSophiaPlayer);
  }
  document.querySelectorAll('.tresse__proof').forEach(initTresseReviews);
  updateAllTresseDeliveries();
  initAllTresseSophiaPlayers();
  window.addEventListener('pageshow', () => updateAllTresseDeliveries());
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.tresse__proof').forEach(initTresseReviews);
    updateAllTresseDeliveries(event.target);
    initAllTresseSophiaPlayers(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
